export default "__VITE_ASSET__BvXdJBG0__"